import { createSlice } from "@reduxjs/toolkit";
import * as API from "./API";
const apiArray = [
  API.isLoginAPI,
  API.isSignUPAPI,
  API.getCountries,
  API.Forgetpassword,
  API.resetpassword,
  API.testQuestion,
  API.socialLogin,
  API.contactAdd,
  API.userView,
  API.getbranch,
  API.Appointmentbook,
  API.submitTest,
  API.ViewBookAppointment,
  API.InvoiceData,
  API.RemoveAppointment,
  API.hearingpdf,
  API.hearingpdfview,
  API.viewUserDetails,
  API.updateUserDetails,
  API.appointmentReferralOption,
  API.testHistory,
  API.appointmenttimeslots,
  API.getReferLink,
];

const userslice = createSlice({
  name: "user",
  initialState: {
    isLoading: false,
    data: [],
    error: false,
  },

  extraReducers: (builder) => {
    apiArray.forEach((api) => {
      builder
        .addCase(api.pending, (state, action) => {
          state.isLoading = true;
        })
        .addCase(api.fulfilled, (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
        })
        .addCase(api.rejected, (state, action) => {
          state.isLoading = false;
          state.error = true;
        });
    });
  },
});

export default userslice.reducer;
